module.exports = __webpack_public_path__ + "img/Support-skill-232.931b064b.png";